module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "pro"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "dl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Lafayette, Louisiana")])]), _vm._v(" "), _c('p', {
    staticClass: "dl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Spring 1953")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("She ran.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She ran as fast as she could, as far as her legs would take her, not daring to stop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not daring to look back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Because if she looked back …")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Let it be a dream,")]), _vm._v(" she told herself, brushing hot tears from her face. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Please, God. Let it be a dream.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not just a dream. A nightmare. One she wished were finally over.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Because what she had done was too horrible to think about. Too horrible to carry with her for years to come.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Don’t look back. Keep going. Don’t stop.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As she rounded the corner near the water’s edge, one leg slid too far forward. She flailed her arms as she lost her balance and barely managed to keep from falling. She’d been running too fast. Not thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She didn’t want to think. Didn’t want to remember.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her head whipped around at a sound in the brush. Was someone coming?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She started off again, deciding to hug the perimeter of the water. If they were looking for her, they would expect her to take the most direct route back to her house.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The grass was tall and thick near the water’s edge, and she held up her bloodied skirt as she trudged through the underbrush. Her toes sank into mud and slime and other things she couldn’t identify. She felt a moment of horror. What other creatures were out here? Would a snake wrap itself around her ankle, inject venom into her bloodstream? Would she die here, alone and unforgiven?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A moan clawed at her throat. If that was her fate, then so be it. She deserved it for what she had done.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Make me forget, Lord,” she whispered in a raspy voice. “Oh, Lord. Forgive me!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her throat stung from the effort to speak. She’d gone hoarse from the screaming. Concentrating on the task of breathing, she glanced over her shoulder. She could no longer see Miss Clara’s carriage house. Her own backyard was just beyond the thicket of trees.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She moved from the water’s edge, picking up her pace as she stepped out of the brush. Her bare feet stomped on the thick, moist grass, and twice she slipped and almost fell.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She heard her name on a whisper of wind. The sound was almost lulling in the quiet night, tempting her to stop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Don’t stop. Don’t stop. Lord forgive me.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her foot hit a rock. Pain shot through her big toe, continued through her foot and then up her leg. Damn, it felt as if her toe had split in two. She took another step forward, crying out as she did. It hurt to move, but she had to keep going. She started off again, but her knees buckled, and she stumbled. She fell to the ground in a heap.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tears of frustration poured from her eyes. If only she could stay right there and die.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was her name again, louder this time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Don’t stop. Keep moving. Lord forgive me.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Digging her fingers into the moist grass and dirt, she heaved herself up and started running.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But where was she going? Back to her house? How could she ever return there?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Helplessly she turned, wondering what direction she should head in, where she should go. The bayou glimmered before her. Beneath the moon’s rays, the water looked like liquid gold. It was a sight that had always given her comfort in the past, and it gave her a measure of comfort now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She stepped forward and gripped the trunk of a sycamore tree. As she paused to rest her body against it, a thought struck her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And grew.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Could she do it? She stared out at the bayou’s vastness, momentarily mesmerized by its tranquility. And in that moment, she didn’t think. She only acted on her pain and desperation, on the feeling of emptiness that filled her so completely.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lifting her skirt, she charged full steam ahead, into the water.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Into a place that would offer peace and solace for what she had done.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caced76c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 78
// module chunks = 0